import React, { useState } from 'react';

function MenuCurso({ lecciones, onSelectLeccion, leccionSeleccionada, progreso }) {
  const leccionesPorModulo = 3;

  const modulos = [];
  for (let i = 0; i < lecciones.length; i += leccionesPorModulo) {
    modulos.push(lecciones.slice(i, i + leccionesPorModulo));
  }

  const [modulosAbiertos, setModulosAbiertos] = useState(
    Array(modulos.length).fill(true)
  );

  const toggleModulo = (index) => {
    setModulosAbiertos((prev) =>
      prev.map((isOpen, i) => (i === index ? !isOpen : isOpen))
    );
  };

  return (
    <div className="modulos">
      {lecciones.length < 1 ? (
        <div className="auteco_error-message">No hay lecciones para mostrar</div>
      ) : (
        modulos.map((modulo, index) => (
          <div key={index}>
            <div className="modulo" onClick={() => toggleModulo(index)}>
              <div className="titulo">Módulo {index + 1}</div>
              <div className='simbolo'>{modulosAbiertos[index] ? '-' : '+'}</div>
            </div>
            {modulosAbiertos[index] && (
              <div className="lecciones">
                {modulo.map((leccion, idx) => {
                  const leccionIndex = idx + index * leccionesPorModulo;
                  const esCompletada = progreso.includes(leccion.id);
                  const esSeleccionable = leccionIndex === 0 || progreso.includes(lecciones[leccionIndex - 1].id);

                  return (
                    <div
                      key={leccion.id}
                      className={`leccion ${leccionSeleccionada?.id === leccion.id ? 'seleccionada' : ''} ${esCompletada ? 'completada' : 'no-completada'}`}
                      onClick={() => esSeleccionable && onSelectLeccion(leccion)} // Permite seleccionar solo si es accesible
                    >
                      {leccion?.titulo}
                      {esCompletada && <span>✓</span>}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        ))
      )}
    </div>
  );
}

export default MenuCurso;
